
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/insider",
      function () {
        return require("private-next-pages/destinations/insider.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/insider"])
      });
    }
  